<!--Online content box render-->
<ng-container *ngIf="itemIndex === -1 && fullRecord?.onlineContents">
  <div
    *ngIf="
      fullRecord?.targetType === 'AG' ||
      fullRecord?.targetType === 'AV' ||
      fullRecord?.targetType === 'ZZ'
    "
    class="online-content"
    fxLayout="column"
  >
    <h6 class="text-center">{{ fullRecord?.onlineContents.title }}</h6>
    <ng-container *ngFor="let item of fullRecord?.onlineContents.items">
      <div *ngIf="item?.href" fxLayout="row">
        <div fxFlex="166px">
          <a
            target="_blank"
            [href]="item.href"
            [matTooltip]="item.title?.length ? item.title : item.href"
          >
            <div class="ellipsis">
              {{ item.title?.length ? item.title : (item.href | truncateUrl) }}
            </div>
          </a>
        </div>
        <div>
          <a target="_blank" [href]="item.href" [matTooltip]="item.href"
            ><mat-icon class="mat-icon-xs">launch</mat-icon></a
          >
        </div>
      </div>
    </ng-container>
  </div>
</ng-container>
